import {useRef, useEffect, useState} from "react";
import { Row, Col, Button } from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import ProductCard from "./ProductCard";
import UIRecommendationHeader from "./UIRecommendationHeader";

export default function ProductSection({
  title,
  subtitle,
  iconType,
  backgroundColor,
  fontColor,
  products = []
}) {

  const rowRef = useRef(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = () => {
    if (!rowRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = rowRef.current;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
  };

  useEffect(() => {
    checkScroll();
    const el = rowRef.current;
    if (!el) return;

    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, [products]);

  const scrollLeft = () => {
    rowRef.current?.scrollBy({ left: -300, behavior: "smooth" }); // scroll 300px left
  };

  const scrollRight = () => {
    rowRef.current?.scrollBy({ left: 300, behavior: "smooth" }); // scroll 300px right
  };
  if (!products || products?.length === 0) {
    return null; // skip section if no products
  }

  return (
    <div style={{ marginBottom: "1rem" }}>
      {/* Section Header */}
      <UIRecommendationHeader
        iconType={iconType}
        title={title}
        subtitle={subtitle}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
      />

      {/* Products Row */}
      <section className="product-row">
        <Row
          gutter={[4, 4]}
          ref={rowRef}
          className="product-row-inner"
        >
          {products?.length && products.map((p) => (
            <Col
              className="product-col"
              key={p.id}
              xs={9} md={7} lg={5}
            >
              <ProductCard {...p} buttonColor={backgroundColor} fontColor={fontColor} />
            </Col>
          ))}
        </Row>


        {canScrollLeft && (<Button  onClick={scrollLeft} className="pd-slide-btn-left" shape="circle" icon={<LeftOutlined />} />)}
        {canScrollRight && (<Button onClick={scrollRight} className="pd-slide-btn-right" shape="circle" icon={<RightOutlined />} />)}
      </section>
    </div>
  );
}